import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { CurrentUserStore } from '../../../../../stores/CurrentUserStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { CustomerExportButton } from './CustomerExportButton'
import { PermissionNames } from '@getgreenline/homi-shared'
import { ImportDropzone } from './ImportDropzone'
import { CustomersApi } from '@getgreenline/customers'
import { Alert } from 'antd'

interface Props {
  isModalOpen: boolean
  loadCustomers: () => Promise<void>
}

interface InjectedProps {
  currentUserStore?: CurrentUserStore
  currentCompanyStore?: CurrentCompanyStore
}

export const CustomersTab: React.FC<Props & InjectedProps> = inject(
  'currentUserStore',
  'currentCompanyStore',
)(
  observer(({ isModalOpen, loadCustomers, currentUserStore, currentCompanyStore }) => {
    const canEditCustomers = currentUserStore!.hasPermissionAtEntity(
      PermissionNames.CAN_EDIT_CUSTOMERS,
      currentCompanyStore!.company!.id,
    )

    return (
      <div>
        <p className='mb-4'>
          Export your customer list, make changes, then import them to bulk update your customer
          list.
        </p>
        <p className='mb-4'>Import limit of 30,000 customers</p>

        <p className='mb-0'>
          All columns are editable <strong>except:</strong>
        </p>
        <ul>
          <li>Greenline ID</li>
          <li>Company ID</li>
          <li>Sign Up Location</li>
          <li>Create Date</li>
          <li>Total Spend</li>
          <li>Loyalty Balance</li>
        </ul>

        <div>
          <Alert
            message={
              <>
                <p className='mb-0'>Please Note:</p>
                <ul>
                  <li>Ensure dates are fomatted as yyyy-mm-dd</li>
                  <li>
                    If you want to create a customer using the import tool, you need to clear the
                    values in the Greenline ID field otherwise it will try to update an existing
                    customer.
                  </li>
                </ul>
              </>
            }
            type='info'
            showIcon
            className='mb-4'
          />
        </div>

        <CustomerExportButton />

        <ImportDropzone
          isModalOpen={isModalOpen}
          hasPermission={canEditCustomers}
          permissionErrorMessage={'You do not have permission to edit customers.'}
          onImport={CustomersApi.importCustomers}
          loadCustomers={loadCustomers}
        />
      </div>
    )
  }),
)
